import React from "react";
import { Link } from "react-router-dom";
import InputBox from "./InputBox";
import { requestPasswordReset } from '../Utils/AuthUtils';
import "./LoginPage.css";

class ForgotPassword extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			usernameOrEmail: '',
			message:  null
		};
		
		this.handleChange = this.handleChange.bind(this);
		this.forgotPasswordSubmit = this.forgotPasswordSubmit.bind(this);
	}

	handleChange(changeEvent) {
		this.setState({ usernameOrEmail: changeEvent.target.value });
	}
	
	// Send the user an email, if they've got an account
	forgotPasswordSubmit() {
		this.setState({ message: "Submitting..."});
		
		const submitObj = {
			url: window.location.protocol + '//' + window.location.hostname, // try to be environment-agnostic
			resetEmail: this.state.usernameOrEmail
		}
		
		requestPasswordReset(submitObj)
			.then( () => this.setState({ message: "You should receive an email with instructions shortly!" }));
	}

	render() {
		const messageElement = this.state.message
			? <p className = "displayMessage">{this.state.message}</p>
			: null;
		
		return (
			<div className="app-container">
				<div className="app-content pass-bgimg">
					<div className="login-page ">
						<div className="panel_center login-form forgot-p-form">
							<form>
								<div className="panel_center_hdr">FORGOT PASSWORD?</div>
								<p>
									{" "}
									Enter your username and we will send you an email with the
									instructions for changing your password.
								</p>
								<div>
									<InputBox
										fieldLabel='USERNAME or EMAIL:'
										name='usernameOrEmail'
										value={this.state.usernameOrEmail}
										handleChange={this.handleChange}
									/>
								</div>
								<div className="actions">
									<div 
										className='actions_submit clickable'
										onClick={this.forgotPasswordSubmit}
									>
										Submit
									</div>
									<Link className="forgot_password" to="login">
										Back To Login
									</Link>
								</div>
							</form>
							{ messageElement }
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export default ForgotPassword;